import { IConfiguration } from './models/iconfiguration';

export const config: IConfiguration = Object.freeze((window as any)['config']);

// This is used to inject configuration into spec files for unit testing.
export const configMock = {
  version: '',
  logging: '', // debug, info, warning, error, none
  portalUrl: '',
  baseApiUrl: '',
  contentUrl: '',
  languages: ['en-GB'], // default first
  defaultLcid: '2057',
  defaultClubId: 1,
  googleAnalyticsTag: '',
  googleMapsAPIKey: '',
  purseConfig: {
    ecash: 1,
    cashBack: 2,
    combined: 3,
    virtualEcash: 4,
    renewalGift: 5,
    virtualLoyalty: 6,
    lifetimeLoyalty: 7,
    corporateGift: 8,
  },
};
